import { useLlm } from '@websolutespa/bom-mixer-llm';
import { Badge } from '../Badge/badge';
import style from './content.module.scss';

export const Content: React.FC = () => {
  const {
    Prompt,
    Scroller,
    ScrollProposition,
    Thread,
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const theme = useLlm(state => state.theme);
  const systemContext = useLlm(state => state.systemContext);
  const messages = useLlm(state => state.messages);
  const selector = `.${style.thread}`;
  return (
    <div className={style.content}>
      <div className={style.head}>
        <Badge mode="user" variant="sm" url={systemContext.avatarUrl} title={systemContext.userName} />
      </div>
      <div className={style.thread}>
        {messages && messages.length > 0 && (
          <Scroller selector={selector}>
            <div className={style.thread}>
              <Thread />
            </div>
          </Scroller>
        )}
        {app && !theme.canvas?.enabled && (
          <div className={style.underlay} aria-hidden />
        )}
        <div className={style.bottom}>
          <ScrollProposition />
          <Prompt />
          {app?.contents.disclaimerFooter && app?.contents.disclaimerShort && (
            <div className={style.disclaimer}>{app?.contents.disclaimerShort || 'EFG Chat version 1.0.'}</div>
          )}
        </div>
      </div>
    </div>
  );
};

